/*
  將虛擬路徑replace為實體路徑
*/
export function ConvertVirtualPathToRealPath(baseUrl, fileUrl) {
  if (fileUrl) {
    return baseUrl + fileUrl.replace('./', '/')
  } else {
    return ''
  }
}